export const LABELS = {
    CLOSE_CLICK: "close-click",
    DONE_CLICK: "done-click",
    HELP_CLICK: "help-click",
    BANNER_CLICK: "payment-banner-click",
};
